
import axios from 'axios';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { addFlashMessage } from '../../../actions/flashMessages.actions';
import { USER } from '../../../utils/constants';
import '../SignIn/SignIn.scss';
import FormTemplate from '../Welcome/FormTemplate';
import { useTranslation } from 'react-i18next';


function ForgotYourPassword({
  user = USER.INFLUENCERS
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [state, setState] = useState({
    loading: false,
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string().email()
      .required(`${t('common.email')} ${t('common.is_required')}`),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: values => {
      setState({ ...state, loading: true });

      let endpoint = '/api/v1/influencers/users/password/new';
      if (user === USER.CLIENTS) {
        endpoint = '/api/v1/clients/agents/password/new';
      }

      axios.get(endpoint, { params: { email: values.email } })
        .then((response) => {
          dispatch(addFlashMessage({
            type: 'success',
            text: response.data.message
          }));
          history.push({
            pathname: user === USER.ADMINS ? '/team/signin' : '/signin'
          });
          setState({ ...state, loading: false });
        })
        .catch(error => {
          setState({ ...state, loading: false });
          dispatch(addFlashMessage({
            type: 'error',
            text: t('common.message_error')
          }));
          console.log(error);
        });
    },
  });


  return <FormTemplate title={t('common.pages.sign_in.forget_password')}
    handleSubmit={formik.handleSubmit}
    submitText={t('common.reset_password')}
    hintText={t('common.reset_password_hint')}
    loading={state.loading}
    user={user} >
    <Form.Group className='mb-3' >
      <Form.Label>
        {t('common.email')}
      </Form.Label>
      <Form.Control
        type='email'
        placeholder={t('common.text')}
        name="email"
        onChange={formik.handleChange}
        value={formik.values.email} />
      <Form.Text className="text-muted danger-text">
        {formik.errors.email}
      </Form.Text>
    </Form.Group>
  </FormTemplate>;
}

ForgotYourPassword.propTypes = {
  user: PropTypes.string,
};
export default React.memo(ForgotYourPassword);
